// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"fad19606","453":"52991258","934":"bd255f0d"}[chunkId] + ".chunk.js";
};